import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import NotFound from "../pages/404";
// import Home from "../pages/Home";
import LoginContainer from "../pages/LoginContainer";
import Filter from "../pages/Filter";
import Requirement from "../pages/Requirement";
import MainContainer from "../pages/MainContainer";
const App = () => (
  <BrowserRouter>
    <Routes>
      {/* <Route exact path="/" element={<Home />} /> */}
      <Route exact path="/" element={<LoginContainer />} />
      <Route exact path="/main" element={<MainContainer />} />
      <Route exact path="/filter" element={<Filter />} />
      <Route exact path="/requirement" element={<Requirement />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);
export default App;
